import { Box, Text } from "@chakra-ui/react";
import { useEffect } from "react";
import { useRouter } from "next/router";

const RedirectPage = () => {
  const router = useRouter();

  useEffect(() => {
    router.replace("/types/cognitive-behavioural-therapy");
  }, [router]);

  return (
    <Box w="100%" h="100vh">
      <Box
        mx="auto"
        mt="40%"
        display="flex"
        flexDirection="column"
        alignItems="center"
      >
        <Text textStyle="h1" p="24px">
          Redirecting
        </Text>
      </Box>
    </Box>
  );
};

export default RedirectPage;
